var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 0C20.371 0 0 20.371 0 45.5C0 70.629 20.371 91 45.5 91C70.629 91 91 70.629 91 45.5C91 20.371 70.629 0 45.5 0ZM65.023 21.3114L74.4762 30.7647L44.9501 60.2964L35.5524 69.6886L26.0992 60.2353L16.5237 50.6542L25.9159 41.2621L35.4914 50.8431L65.023 21.3114Z",
    fill: "#A0A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadChecked);
export default __webpack_public_path__ + "static/media/upload-checked.0cc94251c77e0cea465490db1ff91ede.svg";
export { ForwardRef as ReactComponent };